import { stitch } from 'keo';
import CircularProgress from 'material-ui/CircularProgress';
import PropTypes from 'prop-types';
import r from 'render-dom';

import Button from 'components/ui/Button';

const propTypes = {
    error: PropTypes.object,
    pastDelay: PropTypes.bool,
    retry: PropTypes.func,
};

const style = {
    paddingTop: 100,
    textAlign: 'center',
};

const render = ({ props: { error, pastDelay, retry } }) => {
    if (error) {
        return (
            r.div({ style }, [
                r.p(['Error!']),
                r(Button, { onClick: retry }, ['Retry']),
            ])
        );
    } else if (pastDelay) {
        return (
            r.div({ style }, [
                r(CircularProgress)
            ])
        );
    }

    return null;
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/ui/Loading/index.js